import MainLayout from 'global/MainLayout';
import Image from 'global/Image';
import { Common } from '@stockbit/ui';
import Link from 'next/link';
import { ButtonBackHome, UserNotFoundContainer } from './styled';

const { Text, Flex } = Common;

const UserNotFound = () => (
  <MainLayout>
    <Flex justify="center">
      <UserNotFoundContainer>
        <Image src="/illustration/empty-state.svg" alt="empty" />
        <Text size="16px" weight="bold" mt="10px">
          Oops
        </Text>
        <Text color="#969696" align="center" width="335px" mt="8px">
          This page does not exist. So you got lost. It’s ok. You should
          probably be safer to return to home.
        </Text>
        <Link href="/stream" passHref>
          <ButtonBackHome>Back to Home</ButtonBackHome>
        </Link>
      </UserNotFoundContainer>
    </Flex>
  </MainLayout>
);

export default UserNotFound;
